import {useState} from 'react';
import View from './view';
import {AcceptorAccordionProps} from './model';

export const AcceptorAccordion = (props: AcceptorAccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded(!expanded);
  };

  return View({
    ...props,
    expanded,
    onPress: handleChange,
  });
};
